export default "__VITE_ASSET__CK06mHCK__"